<ng-template #content>
  <ng-container [ngTemplateOutlet]="labelDirective?.template ?? labelTmp ?? defaultLabelTmp" />
  <ng-template #defaultLabelTmp>{{ label }}</ng-template>
</ng-template>
<ng-template #secondary>
  <ng-content select="di-navbar-secondary-menu" />
</ng-template>
